module.exports = __webpack_public_path__ + "img/b_AnevilSirop_right.4da3c470.jpeg";